import { Controller } from "@hotwired/stimulus"
import { useDebounce } from "stimulus-use";

// Connects to data-controller="email-series-step"
export default class extends Controller {
  static targets = ["emailBody", "saveStatus"]
  static outlets = ["auto-save"]
  static debounces = ["autoSaveForm"]

  connect() {
    useDebounce(this, { wait: 200 })
  }

  emailBodyTargetConnected() {
    this.emailBodyTarget.addEventListener('lexxy:change', this.autoSaveForm)
  }

  autoSaveForm = () => {
    this.autoSaveOutlet.save()
  }

  showSaving() {
    this.setSaveStatus(`
      <i class="fa_icon fal fa-spinner-third fa-spin" style="--fa-animation-duration: 1.25s"></i>
      <span>Saving...</span>
    `)
  }

  showSaved(event) {
    if (event?.detail?.success === false) {
      this.setSaveStatus(`
        <i class="fa_icon fas fa-circle fa-2xs text-red-500"></i>
        <span>Failed to save changes</span>
      `)
    } else {
      this.setSaveStatus(`
        <i class="fa_icon fas fa-circle fa-2xs text-green-500"></i>
        <span>Changes saved</span>
      `)
    }
  }

  setSaveStatus(html) {
    this.saveStatusTargets.forEach((target) => { target.innerHTML = html })
  }
}
